import { handleGet } from './common';

class DataService {
  async getCommonData() {
    return await handleGet('/client/data/common');
  }

  async getEventDataV2(lang) {
    return await handleGet('/client/data/event-v2', { lang });
  }

  async getEventData() {
    return await handleGet('/client/data/event');
  }

  async getRsvpDataV2(lang) {
    return await handleGet('/client/data/rsvp-v2', { lang });
  }

  async getRsvpData() {
    return await handleGet('/client/data/rsvp');
  }

  async getGKSData() {
    return await handleGet('/client/data/gks');
  }

  async getBingoData(lang) {
    return await handleGet('/client/data/bingo', { lang });
  }

  async getSaveDateData(lang) {
    return await handleGet('/client/data/save-date', { lang });
  }

  async getGuestPlacesToSit() {
    return await handleGet('/rsvp/guest');
  }
}

export default new DataService();
